export const translations = {
  cs: {
    // Header
    email: "info@urbancage.cz",
    phone: "+420 725 839 593",
    menu: "Menu",

    // Hero Section
    brandName: "UrbanCage®",
    whatIsUrbanCage: "Co je UrbanCage®",
    heroSlogan: "Prémiové multisportovní zařízení nové generace. Postavené, aby vydržela. Navržené, aby zapůsobila.",
    ctaRequestInquiry: "Nezávazná poptávka",

    // Intro Section
    introDesc: "UrbanCage® je multisportovní aréna s evropským patentem, určená pro moderní městské prostředí.\nInstaluje se během jediného dne jako přemístitelná stavba na základě povolení k umístění – bez těžké stavební techniky. Zhodnocuje prostory mezi bytovými domy i školní dvory, lze ji sestavit v různých velikostech a tvarech a vytváří bezpečnou, chráněnou zónu, která motivuje mladé lidi ke sportu. Odolná, antivandalská a bez nároků na údržbu – řešení pro každé město, navržené s ohledem na mladou generaci.",

    // Who Is Urban Cage For
    whoForTitle: "Pro koho je UrbanCage®",
    institution: "Ideální řešení pro obce, školy a veřejná prostranství",
    institutionDesc1: "<strong>Vysoká odolnost vůči vandalismu</strong> – Robustní konstrukce a povrchová ochrana třídy C3 zajišťují dlouhou životnost i v náročných podmínkách.",
    institutionDesc2: "<strong>Bezpečný prostor pro všechny generace</strong> – Certifikované provedení bez ostrých hran zajišťuje bezpečné využití dětmi, studenty i dalšími návštěvníky veřejných prostor",
    institutionDesc3: "<strong>Nízké náklady po celou dobu životnosti</strong> – Bezúdržbová konstrukce výrazně snižuje provozní náklady a pomáhá dlouhodobě chránit vloženou investici",

    architect: "Vytvářejte chytřejší veřejné prostory",
    architectDesc1: "<strong>Více funkcí na menší ploše</strong> – Multifunkční sportovní zóna umožňuje efektivně využít každý metr čtvereční projektu a spojit více sportovních aktivit na jednom místě.",
    architectDesc2: "<strong>Silný argument pro prodej i pronájem</strong> – Moderní sportovní infrastruktura zvyšuje atraktivitu nemovitosti, podporuje komunitní život a přináší obyvatelům skutečný užitek.",
    architectDesc3: "<strong>Bezpečnost bez kompromisů</strong> – Uzavřená konstrukce minimalizuje riziko poškození okolního majetku a umožňuje bezpečný provoz i v bezprostřední blízkosti budov, komunikací a parkovacích ploch.",

    hotel: "Proměňte volný prostor v nezapomenutelný zážitek",
    hotelDesc1: "<strong>Prémiový prvek moderního resortu</strong> – Elegantní design a kvalitní materiály vytvářejí sportovní zónu, která harmonicky zapadá do prostředí a posiluje prestiž celého areálu.",
    hotelDesc2: "<strong>Více hostů, delší pobyty, vyšší spokojenost</strong> – Možnosti aktivního trávení volného času zvyšují atraktivitu resortu pro rodiny, skupiny i firemní klientelu a přispívají k celkové spokojenosti hostů.",
    hotelDesc3: "<strong>Rychlá realizace bez komplikací</strong> – Kompletní instalace během jediného dne umožňuje rychlé uvedení do provozu bez výrazného omezení komfortu hostů nebo běžného chodu hotelu.",

    // Patented Product
    patentedTitle: "UrbanCage® v číslech",
    patentedTitleEU: "UrbanCage® v číslech",
    patentedDesc: "1 den montáže bez těžké stavební techniky\n15 000+ svarů v jednom hřišti pro maximální pevnost\n3 m výška konstrukce, s možností navýšení až na 5 m se sítěmi\n8 hodin autonomního solárního LED osvětlení\n55–60 m² minimální plocha pro plnou funkčnost\n100+ kombinací velikostí, tvarů a konfigurací\n5 let garance na konstrukci\n20+ let provozní životnosti\n0 nákladů na údržbu a elektřinu",
    patentedTagline: "",

    // Model Size Gallery / Configurator
    modelSizeTitle: "UrbanCage® konfigurátor",
    configuratorSubtitle: "Vyberte model, velikost a doplňky",
    dimensionsLabel: "Rozměry:",

    // Flooring Options
    flooringTitle: "Sportovní povrch",
    flooringSubtitle: "Vyberte typ povrchu (jedna možnost)",
    flooringAcrylic: "Akrylátový sportovní povrch",
    flooringGrass: "Umělá tráva",
    flooringPolypropylene: "Polypropylenové modulární dlaždice",
    flooringEPDM: "Samonivelační guma EPDM",
    flooringSBR: "SBR guma",
    // Upgrade Add-ons
    upgradesTitle: "UPGRADE doplňky",
    upgradesSubtitle: "Vyberte množství (více možností)",
    addonFitness: "Fitness modul",
    addonSolarLED: "Autonomní solární LED světla (2 ks)",
    addonBench: "Modul lavička 1,50 m",
    addonTrash: "Odpadkové koše (2 ks)",

    // Total & Export
    exportConfig: "STÁHNOUT VAŠI KONFIGURACI",
    modelRect: "Obdélníkové hřiště",
    sizeCustom: "Na míru",
    sendInquiryBtn: "ODESLAT POPTÁVKU NA VAŠI KONFIGURACI",
    configurationTitle: "Vaše konfigurace UrbanCage®",

    // No Flooring Option
    noFlooring: "Bez povrchu",
    noFlooringDesc: "Pouze připravený podklad",

    // Duplex Coating
    duplexCoating: "Lakování systémem Duplex (dvouvrstvé lakování)",
    duplexCoatingInfo: "Dvouvrstvé práškové lakování – kombinace epoxidového práškového základu a druhé vrstvy polyesterové práškové barvy. Dosahuje třídy korozní odolnosti C4 podle ISO 12944 pro prostředí s vysokou vlhkostí u moře a řek. Výsledkem je 3× odolnější povrch a 5 let garance proti korozi.",

    // Configuration Summary
    configSummaryModel: "Model",
    configSummarySize: "Velikost",
    configSummaryColor: "Barva",
    configSummaryFlooring: "Povrch",
    configSummaryDuplex: "Systém Duplex",
    configSummaryUpgrades: "Doplňky",
    configSummaryYes: "Ano",
    configSummaryNo: "Ne",

    // Urban Cage Select
    selectTitle: "UrbanCage® Select",
    selectSubtitle: "Barevná řešení pro každý projekt",
    visualIdentity: "Vizuální identita — barevné kombinace",
    slateBlaze: "Asphalt Grey",
    slateBlazeDesc: "tmavě šedá a oranžová",
    forestFire: "Moss Green",
    forestFireDesc: "zelená a oranžová",
    obsidianAmber: "Jet Black",
    obsidianAmberDesc: "černá a oranžová",
    oceanGold: "Concrete Grey",
    oceanGoldDesc: "světle šedá a oranžová",

    surfaceSystems: "Sportovní povrchy",
    acrylicSurface: "Akrylátový sportovní povrch",
    acrylicDesc: "Vysoká odolnost a profesionální vlastnosti",
    sbrRubber: "SBR guma",
    sbrDesc: "Elastický povrch odolný proti nárazům",
    artificialTurf: "Umělá tráva",
    artificialDesc: "Ideální pro multisportovní hry",
    modularTiles: "Polypropylenové modulární dlaždice",
    modularDesc: "Rychlá montáž a snadná výměna",
    epdmRubber: "Samonivelační guma EPDM",
    epdmDesc: "Bezešvý a bezpečný povrch",

    qualityStatement: "Práškově lakováno, třída C3 podle ISO 12944 pro maximální trvanlivost",
    customColorNote: "Pro specifičtější požadavky nabízíme plnou personalizaci barevné kombinace",

    // Gallery
    galleryTitle: "Galerie",

    // Video Section
    videoTitle: "Podívejte se na UrbanCage® v akci",

    // Contact Form
    contactTitle: "Kontaktujte nás",
    contactSubtitle: "Zašlete nám vaší poptávku a my vás brzy kontaktuje",
    formName: "Jméno",
    formCompany: "Firma",
    formEmail: "E-mail",
    formPhone: "Telefon",
    formModel: "Model UC",
    formMessage: "Zpráva",
    formSubmit: "ODESLAT POPTÁVKU",
    formSuccess: "Děkujeme! Vaše poptávka byla úspěšně odeslána.",
    formSuccessMessage: "Vaše poptávka byla úspěšně odeslána!",
    formErrorMessage: "Došlo k chybě. Zkuste to prosím znovu.",

    // Footer
    footerCopyright: "© UrbanCage®. Všechna práva vyhrazena.",
    footerNav: "Navigace"
  },

  en: {
    // Header
    email: "info@urbancage.cz",
    phone: "+420 725 839 593",
    menu: "Menu",
    
    // Hero Section
    brandName: "UrbanCage®",
    whatIsUrbanCage: "What is UrbanCage®",
    heroSlogan: "Premium next-generation multi-sport facilities. Built to last. Designed to impress.",
    ctaRequestInquiry: "Request Inquiry",
    
    // Intro Section
    introDesc: "UrbanCage® is an EU-patented multi-sport arena for modern urban environments.\nIt is installed in a single day as a relocatable structure with a placement permit – no heavy construction equipment required. It enhances spaces between residential blocks and school courtyards, can be assembled in various sizes and shapes, and provides a safe, protected zone that motivates young people to play sports. Durable, vandal-resistant, and maintenance-free – a solution for every city, designed with the younger generation in mind.",
    
    // Who Is Urban Cage For
    whoForTitle: "Who is UrbanCage® for",
    institution: "The ideal solution for municipalities, schools and public spaces",
    institutionDesc1: "<strong>High vandal resistance</strong> – Robust construction and C3-class surface protection ensure a long lifespan even in demanding conditions.",
    institutionDesc2: "<strong>A safe space for every generation</strong> – Certified design without sharp edges ensures safe use by children, students and other visitors to public spaces.",
    institutionDesc3: "<strong>Low whole-life costs</strong> – The maintenance-free structure significantly reduces operating costs and helps protect the investment over the long term.",

    architect: "Create smarter public spaces",
    architectDesc1: "<strong>More functions in less space</strong> – A multi-purpose sports zone makes it possible to use every square metre of the project efficiently and combine multiple sports activities in one place.",
    architectDesc2: "<strong>A strong argument for sales and leasing</strong> – Modern sports infrastructure increases the appeal of a property, supports community life and brings real benefits to residents.",
    architectDesc3: "<strong>Safety without compromise</strong> – The enclosed structure minimises the risk of damage to surrounding property and allows safe operation even directly next to buildings, roads and parking areas.",

    hotel: "Turn empty space into an unforgettable experience",
    hotelDesc1: "<strong>A premium feature of a modern resort</strong> – Elegant design and quality materials create a sports zone that blends into its surroundings and strengthens the prestige of the whole property.",
    hotelDesc2: "<strong>More guests, longer stays, higher satisfaction</strong> – Active leisure options increase the resort's appeal for families, groups and corporate clientele and contribute to overall guest satisfaction.",
    hotelDesc3: "<strong>Fast delivery without complications</strong> – Complete installation in a single day allows a fast launch without significantly affecting guest comfort or day-to-day hotel operations.",

    // Patented Product
    patentedTitle: "UrbanCage® in Numbers",
    patentedTitleEU: "UrbanCage® in Numbers",
    patentedDesc: "1 day installation without heavy construction equipment\n15,000+ welds in a single arena for maximum strength\n3 m structure height, with option to extend up to 5 m with nets\n8 hours of autonomous solar LED lighting\n55–60 m² minimum area for full functionality\n100+ combinations of sizes, shapes, and configurations\n5-year structural warranty\n20+ years operational lifespan\n0 maintenance and electricity costs",
    patentedTagline: "",
    
    // Model Size Gallery / Configurator
    modelSizeTitle: "UrbanCage® Configurator",
    configuratorSubtitle: "Choose model, size and add options",
    dimensionsLabel: "Dimensions:",
    
    // Flooring Options
    flooringTitle: "Sport Flooring",
    flooringSubtitle: "Select flooring type (single choice)",
    flooringAcrylic: "Acrylic Sports Surface",
    flooringGrass: "Artificial Grass",
    flooringPolypropylene: "Polypropylene Modular Tiles",
    flooringEPDM: "Self-Leveling EPDM Rubber",
    flooringSBR: "SBR Rubber",
    // Upgrade Add-ons
    upgradesTitle: "UPGRADE Add-ons",
    upgradesSubtitle: "Select quantity (multiple choice)",
    addonFitness: "Fitness Module",
    addonSolarLED: "Autonomous Solar LED Lights (2 units)",
    addonBench: "Bench Module 1.50 m",
    addonTrash: "Trash Bins (2 units)",
    
    // Total & Export
    exportConfig: "DOWNLOAD YOUR CONFIGURATION",
    modelRect: "Rectangular cage",
    sizeCustom: "Custom size",
    sendInquiryBtn: "SEND INQUIRY FOR YOUR CONFIGURATION",
    configurationTitle: "Your UrbanCage® Configuration",
    
    // No Flooring Option
    noFlooring: "No Flooring",
    noFlooringDesc: "Prepared base only",
    
    // Duplex Coating
    duplexCoating: "Duplex Coating System (dual-layer painting)",
    duplexCoatingInfo: "Dual-layer powder coating – a combination of epoxy powder primer and a second layer of polyester powder paint. Achieves corrosion resistance class C4 according to ISO 12944 for high humidity zones near seas and rivers. The result is 3 times more durable coating and 5 years warranty against rust.",
    
    // Configuration Summary
    configSummaryModel: "Model",
    configSummarySize: "Size",
    configSummaryColor: "Color",
    configSummaryFlooring: "Flooring",
    configSummaryDuplex: "Duplex System",
    configSummaryUpgrades: "Add-ons",
    configSummaryYes: "Yes",
    configSummaryNo: "No",
    
    // Urban Cage Select
    selectTitle: "UrbanCage® Select",
    selectSubtitle: "Color solutions for every project",
    visualIdentity: "Visual Identity — Color Combinations",
    slateBlaze: "Asphalt Grey",
    slateBlazeDesc: "Dark grey and orange",
    forestFire: "Moss Green",
    forestFireDesc: "Green and orange",
    obsidianAmber: "Jet Black",
    obsidianAmberDesc: "Black and orange",
    oceanGold: "Concrete Grey",
    oceanGoldDesc: "Light grey and orange",
    
    surfaceSystems: "Sports Flooring",
    acrylicSurface: "Acrylic Sports Surface",
    acrylicDesc: "High durability and professional characteristics",
    sbrRubber: "SBR Rubber",
    sbrDesc: "Elastic and impact-resistant surface",
    artificialTurf: "Artificial Grass",
    artificialDesc: "Perfect for multi-sport games",
    modularTiles: "Polypropylene Modular Tiles",
    modularDesc: "Quick installation and easy replacement",
    epdmRubber: "Self-Leveling EPDM Rubber",
    epdmDesc: "Seamless and safe surface",
    
    qualityStatement: "Powder coated, C3-class according to ISO 12944 for maximum durability",
    customColorNote: "For more specific requirements, we offer full customization of color combinations",
    
    // Gallery
    galleryTitle: "Gallery",
    
    // Video Section
    videoTitle: "See UrbanCage® in action",
    
    // Contact Form
    contactTitle: "Contact Us",
    contactSubtitle: "Send us your inquiry and we will contact you soon",
    formName: "Name",
    formCompany: "Company",
    formEmail: "Email",
    formPhone: "Phone",
    formModel: "Model UC",
    formMessage: "Message",
    formSubmit: "SEND INQUIRY",
    formSuccess: "Thank you! Your inquiry has been sent successfully.",
    formSuccessMessage: "Your inquiry has been sent successfully!",
    formErrorMessage: "An error occurred. Please try again.",
    
    // Footer
    footerCopyright: "© UrbanCage®. All rights reserved.",
    footerNav: "Navigation"
  }
};
